function idify(x) {
  return x.split(" ").join("-");
}

export default {
  idify,
};



// WEBPACK FOOTER //
// ./src/assets/js/common.js